import { Component, OnDestroy, OnInit, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { MutexService } from "common/concurrency/mutex.service";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { InputBase } from "common/form/input/types/input-base";
import { TextInput } from "common/form/input/types/text-input";
import { Subscription } from "rxjs";
import { TranslateModule } from "@ngx-translate/core";

import { InputComponent } from "common/form/input/input.component";

@Component({
	selector: "stages-enactment-activator-execution-start",
	templateUrl: "enactment-activator-execution-start.component.html",
	styleUrls: ["./enactment-activator-execution-start.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ReactiveFormsModule, TranslateModule, InputComponent],
})
export class EnactmentActivatorExecutionStartComponent implements OnInit, OnDestroy {
	private dialog = inject(DialogAdapter);
	private router = inject(Router);
	private mutexService = inject(MutexService);

	readonly keys = input.required<{
		activatorName: string;
		callback(executionTitle: string): void;
	}>();

	executionTitle!: string;
	form = new UntypedFormGroup({});
	inputs: InputBase<string[] | boolean | string>[] = [];

	private routerEventsSubscription?: Subscription;

	ngOnInit(): void {
		this.routerEventsSubscription = this.router.events.subscribe((s) => {
			if (s instanceof NavigationEnd) {
				this.cancel();
			}
		});

		const executionTitleInput = new TextInput({
			key: "executionTitle",
			translateKey: "process.enactment.activator.execution.start.field.executionTitle",
			required: true,
			maxLength: 128,
		});
		this.inputs.push(executionTitleInput);
		this.form.addControl(
			"executionTitle",
			new UntypedFormControl(executionTitleInput.value, executionTitleInput.validators),
		);
	}

	ngOnDestroy(): void {
		if (this.routerEventsSubscription) {
			this.routerEventsSubscription.unsubscribe();
		}
	}

	cancel(): void {
		this.dialog.close("cancel");
	}

	execute(): void {
		this.form.get("executionTitle")!.markAsTouched();

		if (this.form.valid) {
			// eslint-disable-next-line @typescript-eslint/require-await -- TODO: Remove this comment and fix warnings!
			this.mutexService.invoke("activatorExecutionTitle", async () => {
				this.keys().callback(this.form.get("executionTitle")!.value);
				this.dialog.close("ok");
				return null;
			});
		}
	}
}
